<template>
  <div
    ref="editor"
    :style="{ height } "
  />
</template>

<script>
// JSON格式阅读/编辑组件
import JSONEditor from 'jsoneditor';
import 'jsoneditor/dist/jsoneditor.min.css';

export default {
  name: 'JsonEditor',
  props: {
    editable: {
      type: Boolean,
      default: false,
    },
    json: {
      type: [String, Number, Object, Array],
      default: '',
    },
    height: {
      type: String,
      default: 'auto',
    },
  },
  data() {
    return {
      editor: null,
    };
  },
  computed: {
    mode() {
      return this.editable ? 'code' : 'view';
    },
  },
  watch: {
    mode: {
      handler(v) {
        if (this.editor) {
          this.editor.setMode(v);
        }
      },
    },
    json: {
      deep: true,
      immediate: true,
      handler(v) {
        if (this.editor) {
          // update: only mode 'tree/form/view' support.
          // this.editor.update(v);

          // set value will reset the editor.
          this.editor.set(v);
          !this.editable && this.editor.expandAll();
        }
      },
    },
  },
  mounted() {
    const that = this;
    const options = {
      mainMenuBar: true,
      navigationBar: false,
      statusBar: true,
      onChangeText: function(v) {
        try {
          // get value by using '$refs.editor.getValue()', not '@change'
          that.$emit('change', that.editor.get());
          that.$emit('error', null);
        } catch (e) {
          that.$emit('error', e);
        }
      },
    };
    that.editor = new JSONEditor(this.$refs.editor, options);
    that.editor.setMode(that.mode);
    that.editor.set(that.json);
    !this.editable && this.editor.expandAll();
  },

  beforeDestroy() {
    this.editor && this.editor.destroy();
  },

  methods: {
    getValue() {
      if (this.editor) {
        try {
          return this.editor.get();
        } catch (e) {
          return '';
        }
      }
      return '';
    },
  },
};
</script>